import React, { useEffect, useState } from 'react';
import { Caption, H3, H4, PageSection } from 'common/styles/page';
import DashboardCard from './DashboardCard';
import DoughnutGauge from './DoughnutGauge';

import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import { useNavigate } from 'react-router';

import { AggregateType } from 'common/constants/AggregateType';
interface DashboardGreatestStrengthsProps {
  assessment_period_id: number;
}

const DashboardGreatestStrengths = ({ assessment_period_id }: DashboardGreatestStrengthsProps) => {
  const navigate = useNavigate();

  interface Strength {
    label: string;
    sublabel: string;
    value: number;
    summary?: string;
  }

  const [strengths, setStrengths] = useState<Strength[]>([]);
  const { data } = useApiPortalV1AssessmentsResultsListQuery({
    aggregateType: AggregateType.GREATEST_STRENGTHS,
    assessmentPeriodId: assessment_period_id,
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const strengthsData = data[0]?.result;
      const strengths = strengthsData?.map(
        (item: {
          category_name: string;
          option_name: string;
          pillar_name: string;
          ai_summary: string;
          overall_score: number | string | null | undefined; // AI returns sometimes returns a string
        }) => {
          const score =
            item?.overall_score !== undefined && item?.overall_score !== null
              ? parseFloat(item.overall_score as string)
              : 0;
          return {
            label: `${item.category_name}: ${item.option_name}`,
            sublabel: `${item.pillar_name}`,
            value: !isNaN(score) ? parseFloat(score.toFixed(1)) : 0,
            summary: item?.ai_summary,
          };
        }
      );

      setStrengths(strengths);
    }
  }, [data]);

  return (
    <DashboardCard
      title="Greatest Strengths"
      onClick={() => navigate('/app/analytics/?tab=3&option=str')}
    >
      <PageSection display="flex" flexDirection="column">
        {strengths.length === 0 && (
          <p>
            No group in this assessment period had enough respondents to report on without
            identifying individuals.
          </p>
        )}
        {strengths.map((strength, index) => (
          <PageSection
            gap="15px"
            padbottom="10px"
            display="flex"
            alignItems="flex-start"
            key={index}
          >
            <DoughnutGauge
              max={10}
              complete={strength.value}
              precision={1}
              size="small"
              colorize={true}
            />
            <PageSection gap="15px" flex="1">
              <H3>{strength.sublabel}</H3>
              <H4>{strength.label}</H4>
              {strength.summary && <Caption>{strength.summary}</Caption>}
            </PageSection>
          </PageSection>
        ))}
      </PageSection>
    </DashboardCard>
  );
};

export default DashboardGreatestStrengths;

